import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f257b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  key: 0,
  class: "post"
}
const _hoisted_4 = { class: "clearfix mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, " on ", -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "comment"
}
const _hoisted_8 = { class: "clearfix mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, " on ", -1))
const _hoisted_10 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_time_ago = _resolveComponent("time-ago")
  const _component_Pagination = _resolveComponent("Pagination")

  return (_openBlock(), _createBlock(_component_Pagination, {
    "fetch-items": _ctx.fetchItems,
    "use-route": "use-route"
  }, {
    default: _withCtx(({ item }) => [
      item
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (item.__typename === 'Post')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createTextVNode("📜 "),
                      _createVNode(_component_router_link, {
                        class: "title stretched-link",
                        to: '/view/' + item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _hoisted_5,
                      _createVNode(_component_router_link, {
                        class: "over",
                        to: '/view/' + item.forum?.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.forum?.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_time_ago, {
                        class: "pointer float-right",
                        time: item.createdat
                      }, null, 8, ["time"])
                    ]),
                    _createElementVNode("div", {
                      class: "body",
                      innerHTML: item.renderedbody
                    }, null, 8, _hoisted_6)
                  ]))
                : (item.__typename === 'Comment')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createTextVNode("💬 "),
                        _createVNode(_component_router_link, {
                          class: "stretched-link",
                          to: '/view/' + item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Commented")
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _hoisted_9,
                        _createVNode(_component_router_link, {
                          class: "title over",
                          to: '/view/' + item.objectid
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.object.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]),
                        _createVNode(_component_time_ago, {
                          class: "pointer float-right",
                          time: item.createdat
                        }, null, 8, ["time"])
                      ]),
                      _createElementVNode("div", {
                        class: "body",
                        innerHTML: item.renderedbody
                      }, null, 8, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["fetch-items"]))
}